<h3>
  <ng-content select="label"></ng-content>
</h3>
@for (item of allItems; track item) {
  @if (itemTemplate) {
    <div #row class="quick-list-row">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
      @if (!readonly && isDeleteAllowed()) {
        <mad-icon-button data-cy="delete-item-button" (click)="removeItem(item)">
          <mat-icon>delete</mat-icon>
        </mad-icon-button>
      }
    </div>
  }
}
@if (!readonly) {
  <mad-outline-button data-cy="add-item-button" (click)="addItem()" [disabled]="!addPossible || !isAddAllowed()">
    {{ addLabel }}
  </mad-outline-button>
}
